import { MobilePlatform } from "@/utils/deviceDetection";

const DEFAULT_TIMEOUT_MS = 1500;

export const APP_STORE_URL = "https://apps.apple.com/th/app/rakb/id6760022428";
export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.rakb.mobile";

interface AttemptDeepLinkOptions {
  timeoutMs?: number;
}

interface DeepLinkAttemptResult {
  opened: boolean;
}

export const getStoreUrlByPlatform = (platform: MobilePlatform): string => {
  if (platform === "ios") {
    return APP_STORE_URL;
  }

  return PLAY_STORE_URL;
};

export const createRakbDeepLink = (path: string): string => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `rakb://${normalizedPath.replace(/^\//, "")}`;
};

export const attemptDeepLink = (deepLinkUrl: string, options: AttemptDeepLinkOptions = {}): Promise<DeepLinkAttemptResult> => {
  const timeoutMs = options.timeoutMs ?? DEFAULT_TIMEOUT_MS;

  if (typeof window === "undefined") {
    return Promise.resolve({ opened: false });
  }

  return new Promise((resolve) => {
    let hasResolved = false;

    const handleResolve = (opened: boolean): void => {
      if (hasResolved) {
        return;
      }

      hasResolved = true;
      window.clearTimeout(timeoutId);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("pagehide", handlePageHide);
      window.removeEventListener("blur", handleBlur);
      resolve({ opened });
    };

    const handleVisibilityChange = (): void => {
      if (document.visibilityState === "hidden") {
        handleResolve(true);
      }
    };

    const handlePageHide = (): void => {
      handleResolve(true);
    };

    const handleBlur = (): void => {
      // On some mobile browsers, blur fires when app switch starts.
      window.setTimeout(() => {
        if (document.visibilityState === "hidden") {
          handleResolve(true);
        }
      }, 50);
    };

    const timeoutId = window.setTimeout(() => handleResolve(false), timeoutMs);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("pagehide", handlePageHide);
    window.addEventListener("blur", handleBlur);

    try {
      window.location.href = deepLinkUrl;
    } catch {
      handleResolve(false);
    }
  });
};
